/** Single-use links filter panel width (legacy StyledSheet). */
export const schedulingFilterSulWidthCss = "s1svbhyx";

require("./filter_menu_styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_menu_styles.js");